// Prepare the destination session without navigating the visible page.
export function prepareToolSession(tool, requestGrant, signal, { container } = {}) {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) { reject(new Error('App opening cancelled.')); return; }
    const target = new URL(tool.url);
    const request = Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
    const frame = document.createElement('iframe');
    frame.hidden = true; frame.title = `Prepare ${tool.name} sign-in`; frame.referrerPolicy = 'no-referrer';
    target.searchParams.set('breck-login', 'frame'); target.searchParams.set('request', request); frame.src = target.href;
    if (container) {
      target.searchParams.set('breck-embed', '1'); frame.src = target.href;
      frame.className = 'tools-app-frame'; frame.title = tool.name;
      frame.setAttribute('allow', 'camera');
    }
    let requested = false, finished = false;
    const finish = error => {
      if (finished) return;
      finished = true; window.clearTimeout(timer); window.removeEventListener('message', receive);
      signal?.removeEventListener('abort', cancel);
      if (error || !container) frame.remove();
      else frame.hidden = false;
      if (error) reject(error); else resolve(frame);
    };
    const cancel = () => finish(new Error('App opening cancelled.'));
    const receive = async event => {
      if (event.origin !== target.origin || event.source !== frame.contentWindow || event.data?.request !== request || finished) return;
      if (event.data.type === 'breck:sso:challenge' && !requested && /^[A-Za-z0-9_-]{43}$/.test(event.data.challenge || '')) {
        requested = true;
        try {
          const url = new URL(await requestGrant(event.data.challenge));
          const code = new URLSearchParams(url.hash.slice(1)).get('breck-sso');
          if (url.origin !== target.origin || !code) throw new Error('The app returned an invalid sign-in destination.');
          if (!finished) frame.contentWindow.postMessage({ type: 'breck:sso:exchange', request, code }, target.origin);
        } catch (error) { finish(error); }
      } else if (event.data.type === 'breck:sso:ready' && requested) finish();
      else if (event.data.type === 'breck:sso:error') finish(new Error(event.data.message || 'Could not sign in to this app. Please try again.'));
    };
    const timer = window.setTimeout(() => finish(new Error('The app took too long to open. Please try again.')), 30000);
    window.addEventListener('message', receive); signal?.addEventListener('abort', cancel, { once: true });
    (container || document.body).append(frame);
  });
}
